<div fxLayout="column" ngClass.mobile="ignore-back-logos"
     class="w-100 h-100 consent-container"
     fxLayoutAlign="start center">

    <div fxLayout="column" ngClass.desktop="radius-16 shadow-content consent pl-56 pr-56 pt-48 pb-36" ngClass.mobile="pt-24 pl-16 pr-16"
         class="bc-mono-white w-100 consent-card"
         fxLayoutAlign="start center">
        <ui-kit-spinner [spinnerIds]="INITIAL_SPINNER_ID" class="mt-32 mb-32"></ui-kit-spinner>
        @if (!Spinner.isShown(INITIAL_SPINNER_ID)) {
            <div fxLayout="column" fxLayoutAlign="start start" class="w-100">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px"
                     class="bc-primary-green-50 radius-12 pt-8 pb-8 pl-12 pr-12">
                    <img [src]="oauthHolderService.consentData.clientLogoUrl || NO_LOGO_URL"
                         class="client-badge-logo bc-mono-white">
                    <span class="t1-semi-bold c-primary-gray-900">{{ clientName }}</span>
                </div>
                <div class="h3-semi-bold c-primary-gray-900 mt-16">
                    {{ title | translate: {
                        clientOrganizationName: clientOrganizationName,
                        externalOrgName: externalOrgName,
                        clientName: clientName
                    } }}
                </div>
                @if (!isAuthorityFlow && taxIncomeBin) {
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" class="org-card w-100 mt-16 t-button-small">
                        <ui-kit-svg name="ic_company" class="i-16 flex-none"></ui-kit-svg>
                        <span class="c-primary-gray-900">
                            {{ 'i18n_auth_consentOrganizationDataWithBin'
                                | translate: {organizationName: taxIncomeOrgName, bin: taxIncomeBin} }}
                        </span>
                    </div>
                }
                @if (!isAuthorityFlow) {
                    <div class="t4 c-primary-gray-600 mt-16">
                        {{ 'i18n_auth_consentNewSubtitle' | translate: {clientName: clientName} }}
                    </div>

                    <ng-container *ngTemplateOutlet="sectionHeader;
                        context: {section: 'personal', title: 'i18n_auth_consentSectionPersonalData', topClass: 'mt-32'}"/>

                    @if (hasPersonalScope) {
                        <auth-expand-card class="mt-16" [title]="'i18n_auth_consentCardPersonalData' | translate">
                            <ui-kit-svg expandCardIcon name="ic_user" class="i-16"></ui-kit-svg>
                            <div class="scope-grid">
                                @for (label of personalScopeLabels; track label) {
                                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                        <ui-kit-svg name="ic_circle_checkmark" class="i-16 flex-none"></ui-kit-svg>
                                        <span class="t4 c-primary-gray-900">{{ label }}</span>
                                    </div>
                                }
                            </div>
                        </auth-expand-card>
                    }
                    <auth-expand-card class="mt-8" [title]="'i18n_auth_consentCardBiometric' | translate">
                        <ui-kit-svg expandCardIcon name="ic_full_screen" class="i-16"></ui-kit-svg>
                        <div class="t4 c-primary-gray-900">{{ 'i18n_auth_consentCardBiometricText' | translate }}</div>
                    </auth-expand-card>

                    @if (scopes.includes('bin') && organization) {
                        <auth-expand-card class="mt-8"
                                          [title]="'i18n_auth_consentOrganizationData'
                                              | translate: {organizationName: organization.name}">
                            <ui-kit-svg expandCardIcon name="ic_company" class="i-16"></ui-kit-svg>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                <ui-kit-svg name="ic_circle_checkmark" class="i-16 flex-none"></ui-kit-svg>
                                <span class="t4 c-primary-gray-900">
                                    {{ 'i18n_auth_scope#Bin' | translate }} {{ organization.bin }}
                                </span>
                            </div>
                        </auth-expand-card>
                    }

                    @if (scopes.includes('legal_entity') && legalEntity) {
                        <auth-expand-card class="mt-8"
                                          [title]="'i18n_auth_consentOrganizationDataWithBin'
                                              | translate: {organizationName: legalEntityName, bin: legalEntity.bin}">
                            <ui-kit-svg expandCardIcon name="ic_company" class="i-16"></ui-kit-svg>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                <ui-kit-svg name="ic_circle_checkmark" class="i-16 flex-none"></ui-kit-svg>
                                <span class="t4 c-primary-gray-900">{{ 'i18n_auth_scope#LegalEntity' | translate }}</span>
                            </div>
                        </auth-expand-card>
                    }

                    @if (hasProviderSection) {
                        <div class="divider-thin w-100 mt-24"></div>
                        <ng-container *ngTemplateOutlet="sectionHeader;
                            context: {section: 'banks', title: 'i18n_auth_consentSectionBankData', topClass: 'mt-24'}"/>
                        <div class="t4 c-primary-gray-900 mt-16">{{ allProvidersNames }}</div>
                        @for (item of providersToScopes; track item) {
                            <auth-expand-card class="mt-16" [title]="'i18n_auth_consentCardBankSecret' | translate">
                                <div expandCardIcon fxLayout="row" fxLayoutAlign="start center">
                                    @for (provider of item.providers; track provider) {
                                        <img class="circle app-logos bc-mono-white" [src]="provider.logoUrl || NO_LOGO_URL">
                                    }
                                </div>
                                <div class="scope-grid">
                                    @for (label of item.scopeLabels; track label) {
                                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                                            <ui-kit-svg name="ic_circle_checkmark" class="i-16 flex-none"></ui-kit-svg>
                                            <span class="t4 c-primary-gray-900">{{ label }}</span>
                                        </div>
                                    }
                                </div>
                            </auth-expand-card>
                        }
                    }
                }

                @if (hasSignScope) {
                    @if (!isAuthorityFlow) {
                        <div class="divider-thin w-100 mt-24"></div>
                        <ng-container *ngTemplateOutlet="sectionHeader;
                            context: {section: 'sign', title: 'i18n_auth_consentSectionSignables', topClass: 'mt-24'}"/>
                    }
                    <auth-expand-card [ngClass]="isAuthorityFlow ? 'mt-24' : 'mt-16'"
                                      [title]="('i18n_auth_consentCardSignables' | translate) + ' (' + signables.length + ')'">
                        <ui-kit-svg expandCardIcon name="ic_document" class="i-16"></ui-kit-svg>
                        <div fxLayout="column" fxLayoutGap="8px">
                            @for (signable of signables; track signable) {
                                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="8px">
                                    <span class="t4 c-primary-gray-900 no-wrap text-ellipsis signable-name"
                                          [title]="signable.translatedName || signable.name">
                                        {{ signable.translatedName || signable.name }}
                                    </span>
                                    @if (!!signable.link) {
                                        <ui-kit-button type="text"
                                                       [isSmall]="true"
                                                       [disabled]="processing"
                                                       (clickListener)="viewDocument(signable)"
                                                       [label]="'i18n_auth_buttonViewDocument' | translate">
                                        </ui-kit-button>
                                    }
                                </div>
                            }
                        </div>
                    </auth-expand-card>
                }

                @if (!isAuthorityFlow) {
                    <div class="divider-thin w-100 mt-24"></div>

                    <div fxLayout="column" class="summary-card w-100 mt-24">
                        <div class="t-button-small c-primary-gray-900 text-center">
                            {{ 'i18n_auth_consentSummaryTitle' | translate }}
                        </div>
                        <div fxLayout="column" fxLayoutGap="8px" class="mt-24">
                            @if (coidConsentDraft?.consentExpiresAt; as expiresAt) {
                                <div class="t4 summary-row">
                                    <span class="c-primary-gray-800">
                                        {{ 'i18n_auth_consentSummaryExpiresLabel' | translate }}
                                    </span>
                                    <span class="c-primary-gray-900 summary-row-value">
                                        {{ 'i18n_auth_consentSummaryExpiresValue'
                                            | translate: {date: (expiresAt | date: 'dd.MM.yyyy')} }}
                                    </span>
                                </div>
                                <div class="divider-thin w-100"></div>
                            }
                            @if (coidConsentDraft; as draft) {
                                <div class="t4 summary-row">
                                    <span class="c-primary-gray-800">
                                        {{ 'i18n_auth_consentSummaryPurposeLabel' | translate }}
                                    </span>
                                    <span class="c-primary-gray-900 summary-row-value">
                                        @for (code of coidServiceCodes; track code) {
                                            {{ ('i18n_auth_susService#' + code) | translate }}{{ $last ? '' : ', ' }}
                                        }
                                    </span>
                                </div>
                                <div class="divider-thin w-100"></div>
                            }
                            @if (taxIncomePeriodYear && taxIncomePeriodHalfYear) {
                                <div class="t4 summary-row">
                                    <span class="c-primary-gray-800">
                                        {{ 'i18n_auth_consentSummaryTaxPeriodLabel' | translate }}
                                    </span>
                                    <span class="c-primary-gray-900 summary-row-value">
                                        {{ ('i18n_auth_consentSummaryTaxPeriod#' + taxIncomePeriodHalfYear)
                                            | translate: {year: taxIncomePeriodYear} }}
                                    </span>
                                </div>
                                <div class="divider-thin w-100"></div>
                            }
                            <div class="t4 summary-row">
                                <span class="c-primary-gray-800">
                                    {{ 'i18n_auth_consentSummaryRecipientLabel' | translate }}
                                </span>
                                <span class="c-primary-gray-900 summary-row-value">{{ clientName }}</span>
                            </div>
                        </div>
                    </div>

                    @if (hasB2c2iScope) {
                        <div class="w-100 mt-24 t2-semi-bold c-primary-gray-900 text-center bc-primary-green-50 radius-4 p-8">
                            {{ 'i18n_auth_warningMfoTransfer' | translate }}
                        </div>
                    }

                    <ui-kit-checkbox class="mt-24" appearance="small"
                                     [checked]="consentChecked"
                                     (change)="consentChecked = $event.checked">
                        @if (hasProviderSection) {
                            <span class="t4 c-primary-gray-900 underline-links"
                                  [innerHTML]="('i18n_auth_consentCheckboxText' | translate) | safeHtml"
                                  [commonsClickById]="{viewCoidConsent}"></span>
                        } @else {
                            <span class="t4 c-primary-gray-900">{{ 'i18n_auth_consentCheckboxTextPlain' | translate }}</span>
                        }
                    </ui-kit-checkbox>
                }
            </div>
            <div fxLayout="column"
                 fxLayoutAlign="start center"
                 class="mt-40 radius-8"
                 ngClass.mobile="mobile-sticky w-100 p-16 gray-shadow">
            <ui-kit-button
                    fxLayout="column"
                    spinnerId="submit"
                    [color]="buttonAcceptColor"
                    [disabled]="processing || Spinner.isShown('reject') || (!isAuthorityFlow && !consentChecked)"
                    (clickListener)="acceptConsent(true)"
                    ngClass.mobile="mt-24 w-100"
                    [label]="buttonAcceptLabel | translate"
                    [autoFocus]="true">
                </ui-kit-button>
                <ui-kit-button type="text"
                               class="mt-16"
                               fxFlex.mobile
                               spinnerId="reject"
                               [disabled]="processing || Spinner.isShown('submit')"
                               [label]="buttonRejectLabel | translate"
                               (clickListener)="acceptConsent(false)">
                </ui-kit-button>
                @if (!isAuthorityFlow) {
                    @if (isWebView) {
                        <div class="t5 c-primary-gray-600 text-center mt-16">{{ 'i18n_auth_consentFooterPlain' | translate }}</div>
                    } @else {
                        <div class="t5 c-primary-gray-600 text-center mt-16 underline-links"
                             [innerHTML]="('i18n_auth_consentFooter' | translate: {cabinetUrl: cabinetUrl}) | safeHtml">
                        </div>
                    }
                }
            </div>
        }
    </div>
</div>

<ng-template #sectionHeader let-section="section" let-title="title" let-topClass="topClass">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px" class="w-100" [ngClass]="topClass">
        @if (visibleSections.length > 1) {
            <div fxLayout="row" fxLayoutAlign="center center"
                 class="section-number bc-primary-green-50 radius-8 t2-semi-bold c-primary-gray-900">
                {{ visibleSections.indexOf(section) + 1 }}
            </div>
        }
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex
             class="section-pill bc-primary-green-50 radius-8 t2-semi-bold c-primary-gray-900">
            {{ title | translate }}
        </div>
    </div>
</ng-template>
